import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose, setDisplayName } from 'recompose';

import immutableToJS from 'helpers/immutableToJS';
import {
  injectIntl,
  HeaderTitle,
} from 'components';
import { selectState } from 'redux/selectors';
import FarmPractices from './components/FarmPractices';

class RegenPractices extends Component {
  static contextTypes = {
    currentUser: PropTypes.shape({}),
    isFarmer: PropTypes.bool,
    isMember: PropTypes.bool,
  };

  static propTypes = {
    formatMessage: PropTypes.func.isRequired,
    buyers: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
      }),
    ).isRequired,
  };

  state = {
    expanded: false,
  };

  componentWillMount() {

  }


  render() {
    const {formatMessage} = this.props;
    return (
        <div style={{margin:'40px'}}>
            <HeaderTitle>{formatMessage('Regen Practices')}</HeaderTitle>
            <div style ={{marginBottom:'30px', fontSize:'30px'}}> Cropland Management Practices</div>
            <FarmPractices/>
        </div>
    ) 
  }   
}

/* istanbul ignore next */
const mapStateToProps = state => ({
  ...selectState('buyers', 'buyers')(state, 'buyers'),
});

export default compose(
  setDisplayName('RegenPractices'),
  connect(
    mapStateToProps,
    null,
  ),
  immutableToJS,
  injectIntl,
)(RegenPractices);
